// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__nm2K0","rootCenter":"LoadMoreObserver_rootCenter__3uRou","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2_-6J"};